import { useEffect, useState } from "react";
import { api, errText } from "../../lib/api";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { toast } from "sonner";
import { Check, Loader2 } from "lucide-react";

export const SignatureEditor = ({ open, onOpenChange }) => {
  const [sig, setSig] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (open) api.get("/admin/my-signature").then((r) => setSig(r.data.signature || r.data.suggested || "")).catch(() => {});
  }, [open]);
  const save = async () => {
    setLoading(true);
    try { await api.put("/admin/my-signature", { signature: sig }); toast.success("Signature saved"); onOpenChange(false); }
    catch (e) { toast.error(errText(e)); }
    finally { setLoading(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="signature-editor">
        <DialogHeader>
          <DialogTitle>Your email signature</DialogTitle>
          <DialogDescription>This sign-off is appended to the contact replies you send. We've pre-filled it with your name — tweak it to make it yours.</DialogDescription>
        </DialogHeader>
        <Textarea value={sig} onChange={(e) => setSig(e.target.value)} placeholder={"Warm regards,\nJane · CritterPosts Support"} data-testid="signature-body" className="rounded-lg min-h-[120px] text-sm" maxLength={500} />
        <div data-testid="signature-preview" className="rounded-xl border border-slate-200 overflow-hidden">
          <div className="bg-[#12234A] px-4 py-2.5"><span className="text-white text-sm font-bold">CritterPosts<span className="text-[#F5551E]">.ca</span></span></div>
          <div className="p-4 bg-white">
            <p className="text-[13px] text-slate-600">Hi Jane,</p>
            <p className="text-[13px] text-slate-400 italic mt-1">…your reply message appears here…</p>
            <p className="text-[13px] text-slate-700 mt-4 whitespace-pre-wrap border-t border-slate-100 pt-3">{(sig && sig.trim()) ? sig : "Warm regards,\nThe CritterPosts.ca Team"}</p>
          </div>
        </div>
        <div className="flex justify-end">
          <Button onClick={save} disabled={loading} data-testid="signature-save" className="rounded-xl bg-[#F5551E] hover:bg-[#E04812] text-white gap-1">{loading ? <Loader2 size={15} className="animate-spin" /> : <Check size={15} />} Save signature</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
